import { rankingItems } from '@/mocks/home';

export default function Ranking() {
  const getTagStyle = (tag: string) => {
    if (tag === '爆') return 'bg-primary-500 text-white';
    if (tag === '热') return 'bg-accent-500 text-white';
    return 'bg-secondary-500 text-white';
  };

  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-white';
    if (rank === 2) return 'bg-accent-500 text-white';
    if (rank === 3) return 'bg-secondary-500 text-white';
    return 'bg-background-200 text-foreground-500';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            热度榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时更新的热门内容排行榜，看看大家都在关注什么
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-3 md:gap-4 px-5 md:px-6 py-4 border-b border-background-200/70 last:border-b-0 hover:bg-background-100/60 transition-colors cursor-pointer group"
            >
              <div className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${getRankStyle(item.rank)}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>
              <div className="hidden sm:block text-xs text-accent-600 whitespace-nowrap font-medium">
                {item.hot}
              </div>
              <span className={`px-2 py-0.5 rounded text-xs font-semibold whitespace-nowrap flex-shrink-0 ${getTagStyle(item.tag)}`}>
                {item.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">
                {item.views}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}